import { IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow, IonText } from '@ionic/react';
import { ReactNode, RefObject, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Footer from '@components/Footer';
import styles from '@components/pageTypes/UnauthenticatedPage.module.css';
import HugeText from '@components/text/HugeText';
import { imageUrl } from '@utils/imageUtils';

type Props = {
  children: ReactNode;
  contentRef?: RefObject<HTMLIonContentElement>;
  image?: 'activeElders' | 'mapBusSelfie' | 'personComputer' | 'stripOfActivities';
  instructionsKey?: string;
  titleKey?: string;
};

const UnauthenticatedPage = ({ children, contentRef, image, instructionsKey, titleKey }: Props) => {
  const intl = useIntl();

  const renderImage = useCallback(() => {
    if (!image) {
      return null;
    }
    if (image === 'activeElders') {
      return (
        <IonImg alt={intl.formatMessage({ id: 'accessibility.altTags.activeElders' })} src={imageUrl('activeElders')} />
      );
    }
    if (image === 'mapBusSelfie') {
      return (
        <IonImg alt={intl.formatMessage({ id: 'accessibility.altTags.mapBusSelfie' })} src={imageUrl('mapBusSelfie')} />
      );
    }
    if (image === 'personComputer') {
      return (
        <IonImg
          alt={intl.formatMessage({ id: 'accessibility.altTags.personComputer' })}
          src={imageUrl('personComputer')}
        />
      );
    }
    return (
      <IonImg
        alt={intl.formatMessage({ id: 'accessibility.altTags.stripOfActivities' })}
        src={imageUrl('stripOfActivities')}
      />
    );
  }, [image, intl]);

  return (
    <IonPage className={styles.page}>
      <IonContent ref={contentRef}>
        <IonGrid className={styles.contentGrid} fixed>
          <IonRow>
            <IonCol className="ion-text-center">
              <img
                alt={intl.formatMessage({ id: 'accessibility.altTags.purpleLogo' })}
                className={styles.logo}
                src={imageUrl('logoPurple')}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              {titleKey && (
                <h1 className={styles.title}>
                  <HugeText>
                    <FormattedMessage id={titleKey} />
                  </HugeText>
                </h1>
              )}
              {instructionsKey && (
                <IonText>
                  <FormattedMessage id={instructionsKey} />
                </IonText>
              )}
              {children}
            </IonCol>
          </IonRow>
        </IonGrid>
        <div className={styles.imageArea}>{renderImage()}</div>
        <Footer />
      </IonContent>
    </IonPage>
  );
};

export default UnauthenticatedPage;
